import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./app/query-client";
import { LanguageProvider } from "./i18n";
import "./styles.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const app = (
  <React.StrictMode>
    <LanguageProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </LanguageProvider>
  </React.StrictMode>
);

// If the page was pre-rendered at build time, hydrate to avoid content flash.
// Otherwise, do a fresh client render (SPA fallback / dev mode).
if (rootElement.hasAttribute("data-prerendered")) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

